import { registerStyles } from "../utils/registerStyles";
import React, { useEffect, useMemo, useRef } from "react";
import { FaTimes } from "react-icons/fa";
import { timestampExportDocument } from "../utils/timestampExport";

export default function TimestampExportPopup({ companyName, range, sessions, groupForSession, onClose }) {
  const frame = useRef(null);
  const close = useRef(null);
  const document = useMemo(() => timestampExportDocument({ companyName, range, sessions, groupForSession }),
    [companyName, range, sessions, groupForSession]);
  useEffect(() => {
    const previous = window.document.activeElement;
    close.current?.focus();
    const onKey = (event) => { if (event.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => { window.removeEventListener("keydown", onKey); if (previous?.isConnected) previous.focus(); };
  }, [onClose]);
  return <div className="timestamp-export-backdrop" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <section className="timestamp-export-modal" role="dialog" aria-modal="true" aria-labelledby="timestamp-export-title">
      <header>
        <div><h2 id="timestamp-export-title">Exportera Skatteverket</h2><p>{range.from} – {range.to} · Samma pass och dagar som i Enkel-vyn</p></div>
        <button ref={close} type="button" onClick={onClose} aria-label="Stäng export"><FaTimes /></button>
      </header>
      <div className="timestamp-export-actions"><span>Välj ”Spara som PDF” i utskriftsdialogen.</span>
        <button type="button" onClick={() => { frame.current?.contentWindow?.focus(); frame.current?.contentWindow?.print(); }}>Skriv ut / Spara som PDF</button>
      </div>
      <iframe ref={frame} title="Förhandsvisning av tidstämplingar" srcDoc={document} />
    </section>
  </div>;
}

// Styles live with this component; keep selectors and responsive rules together.
registerStyles("TimestampExportPopup", `
.timestamp-export-button { margin-left: auto; align-self: flex-end; padding: 11px 16px; border: 0; border-radius: 10px; background: #6323ef; color: white; font: inherit; font-size: 13px; font-weight: 700; cursor: pointer; }
.timestamp-export-button:disabled { opacity: .5; cursor: not-allowed; }
.timestamp-export-backdrop { position: fixed; inset: 0; z-index: 1100; display: grid; place-items: center; padding: 20px; background: #121c2b99; }
.timestamp-export-modal { width: min(920px, 100%); height: 90dvh; display: flex; flex-direction: column; overflow: hidden; background: #fff; border-radius: 14px; box-shadow: 0 24px 70px #0004; }
.timestamp-export-modal header { display: flex; justify-content: space-between; gap: 12px; padding: 18px 22px; }
.timestamp-export-modal h2 { margin: 0; font-size: 20px; }
.timestamp-export-modal p { margin: 8px 0 0; font-size: 12px; }
.timestamp-export-modal header button { align-self: flex-start; border: 0; background: none; padding: 5px; cursor: pointer; }
.timestamp-export-actions { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px; padding: 12px 22px; background: #f4f1ff; font-size: 12px; }
.timestamp-export-actions button { padding: 10px 14px; border: 0; border-radius: 8px; background: #6323ef; color: white; font: inherit; font-weight: 700; cursor: pointer; }
.timestamp-export-modal iframe { width: 100%; flex: 1; min-height: 0; border: 0; }
`);
